<script setup>
/* eslint-disable */
import { onMounted, computed, watch, ref, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import PreFixtureDoubleMarket from './PreFixtureDoubleMarket.vue';
import LiveFixtureDoubleMarket from './LiveFixtureDoubleMarket.vue';
import { useTimedSportStore } from '@/stores/timed_sport';
import FixtureSkeletonLoader from './FixtureSkeletonLoader.vue';

const competition_closed = ref(false);
const router = useRouter();
const timedSportStore = useTimedSportStore();

const toggleCompetition = () => {
	competition_closed.value = !competition_closed.value;
	if (!competition_closed.value && !fetched.value) {
		fetchFixtures();
	}
};

const props = defineProps({
	index: {
		type: Number,
		required: true,
	},
	primary_overview_market: {
		type: Object,
		required: true,
	},
	secondary_overview_market: {
		type: Object,
		required: true,
	},
	time: {
		type: String,
		default: 'today',
	},
	sport_id: {
		type: Number,
		default: 1,
	},
	competition: {
		type: Object,
		required: true,
	},
	pre_only: {
		type: Boolean,
		default: false,
	},
});


const visible = ref(false);
const loading = ref(false);
const fetched = ref(false);

const visibilityChanged = (isVisible, entry) => {
	if (isVisible) fetchFixtures();
}

const fetchFixtures = () => {
	if (fetched.value) return;
	loading.value = true;

	timedSportStore.fetchFixturesByCompetitionByTime(props.sport_id, props.competition.id, props.time, props.pre_only).then(() => {
		fetched.value = true;
		loading.value = false;
	}).catch(() => {
		loading.value = false;
	});
}

onMounted(() => {
	if (props.index < 3) {
		// https://www.youtube.com/watch?v=yQwMV5aJWRQ
		fetchFixtures();
	}
})

onUnmounted(() => {
	timedSportStore.leaveLiveFavouriteFixtures(props.competition.id);
})

const fixtures = computed(() => {
	const fixtures = timedSportStore.fixtures_by_competition?.[props.competition.id] ?? [];
	return _.sortBy(fixtures, 'start_datetime', 'asc');
})

</script>


<template>
	<div>
		<div class="live-info-inner">
			<div  v-observe-visibility="visibilityChanged" class="live-info-team">
				<div class="live-match">
					<div class="team-flag">
						<img :src="'/assets' + competition.region_icon_url" alt="">
					</div>
					<div class="live-match-name">
						<h3>{{ competition.region_name }} - {{ competition.name }} </h3>
					</div>
				</div>
			</div>

			<div class="full-time-top top-title-dash " :class="{'totals_new-grid': primary_overview_market?.market_type == 'totals_new', 'handicap_new_grid': primary_overview_market?.market_type == 'handicap_new'}">
				<span v-if="primary_overview_market?.market_type == 'totals_new' || primary_overview_market?.market_type == 'handicap_new'"/>
				<template v-for="(odd, id) in primary_overview_market?.odd_names" :key="id">
					<span v-if="odd?.length >= 1">{{ odd }}</span>
				</template>
			</div>

			<div class="match-goal-top top-title-dash" :class="{'totals_new-grid': secondary_overview_market?.market_type == 'totals_new', 'handicap_new_grid': secondary_overview_market?.market_type == 'handicap_new'}">
				<span v-if="secondary_overview_market?.market_type == 'totals_new' || secondary_overview_market?.market_type == 'handicap_new'"/>
				<template v-for="(odd, id) in secondary_overview_market?.odd_names" :key="id">
					<span  v-if="odd?.length >= 1">{{ odd }}</span>
				</template>
				<span class="bet-column-empty">
					<div @click="toggleCompetition" class="market-arrow">
						<a class="market-arrow-icon" :class="competition_closed ? 'market-arrow-icon-closed' : ''"></a>
					</div>
				</span>

			</div>
		</div>

		<template v-if="!competition_closed">
			<div v-if="loading">
				<FixtureSkeletonLoader :rows="competition.fixtures_count"  />
			</div>

			<template v-else v-for="(fixture, index) in fixtures" :key="index">
				<LiveFixtureDoubleMarket v-if="fixture.live"
					:primary_overview_market="primary_overview_market"
					:secondary_overview_market="secondary_overview_market"
					:fixture="fixture"
				/>

				<PreFixtureDoubleMarket v-if="!fixture.live"
					:primary_overview_market="primary_overview_market"
					:secondary_overview_market="secondary_overview_market"
					:fixture="fixture"
				/>

			</template>
		</template>
	</div>
</template>

<style scoped>
.market-arrow {
	display: grid;
	align-items: center;
	justify-content: center;
	height: 100%;
	cursor: pointer;
}

.market-arrow-icon {
	content: url('@/assets/images/chevron-right.svg');
	filter: invert(65%);
	transform: scale(.8);
	transform: rotate(270deg);
	width: 20px;
}

.market-arrow-icon-closed {
	content: url('@/assets/images/chevron-right.svg');
	filter: invert(65%);
	transform: scale(.8);
	transform: rotate(90deg);
	width: 20px;
}
</style>
